<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Norm-Cen" id="auto_bookmark_table_of_contents_1"><span><span style=" font-style: italic; font-size: 1.00em;">For Holli, who so eagerly follows Thaddeus on his quest.</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?71d92a02